// TotalInventoryExpired Getters

export const getTotalInventoryExpiredList = state => {
  return state.totalInventoryExpiredList
}

export const getTotalInventoryExpiredCount = state => {
  return state.totalInventoryExpiredCount
}
